<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import LeSuccessModal from "@/components/LeSuccessModal.vue";
import { MatomoHelper } from "@/helpers";
import { type BusinessSubscriptionModal, type BusinessSubscriptionType, MatomoEventCategory } from "@/types";

import LeBusinessSubscriptionRequestModal from "./LeBusinessSubscriptionRequestModal.vue";

const props = defineProps<{
  subscriptionType?: BusinessSubscriptionType;
}>();

const modal = defineModel<BusinessSubscriptionModal | undefined>();

const { t } = useI18n();

const isTrial = computed<boolean>(() => props.subscriptionType !== "professional");
const successText = computed<string>(() =>
  isTrial.value
    ? t("le-business-subscription-success-modal.text-trial")
    : t("le-business-subscription-success-modal.text-default")
);

const onCloseRequestModal = (didSubmit: boolean) => {
  if (didSubmit) {
    modal.value = "success";

    const action = MatomoHelper.getBusinessSubscriptionAction(props.subscriptionType);
    if (!action) {
      return;
    }

    MatomoHelper.sendEvent(MatomoEventCategory.SubscriptionPageBusiness, action, 'Clicked button "Send request"');

    return;
  }

  modal.value = undefined;
};

const onCloseSuccessModal = () => {
  modal.value = undefined;
};
</script>

<template>
  <LeBusinessSubscriptionRequestModal
    :is-open="modal === 'request'"
    :subscription-type="props.subscriptionType"
    size="lg"
    @close="onCloseRequestModal($event)"
  />

  <LeSuccessModal
    :title-text="t('le-business-subscription-success-modal.title')"
    :body-text="successText"
    :confirm-text="t('le-business-subscription-success-modal.understood')"
    :is-open="modal === 'success'"
    @close="onCloseSuccessModal()"
  />
</template>
